import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    user_running: [],
    inputSearching: "",
    sizePage: 10,

    rtDay: [],
    rtDaySortField: "distance",
    rtDaySortOrder: "ascending",
    rtDayPage: 1,
    rtDayResults: 0,

    rtWeek: [],
    rtWeekSortField: "distance",
    rtWeekSortOrder: "ascending",
    rtWeekPage: 1,
    rtWeekResults: 0,

    rtMonth: [],
    rtMonthSortField: "distance",
    rtMonthSortOrder: "ascending",
    rtMonthPage: 1,
    rtMonthResults: 0,

    rtLastMonth: [],
    rtLastMonthSortField: "distance",
    rtLastMonthSortOrder: "ascending",
    rtLastMonthPage: 1,
    rtLastMonthResults: 0,

    rtAll: [],
    rtAllSortField: "distance",
    rtAllSortOrder: "ascending",
    rtAllPage: 1,
    rtAllResults: 0,
  },
  mutations: {
    setUserRunning(state: any, result: any) {
      state.user_running = result
    },
    setInputSearching(state: any, result: any) {
      state.inputSearching = result
    },
    setRtDay(state: any, result:any) {
      state.rtDay = result
    },
    setDaySorting(state: any, config:any) {
      state.rtDaySortField = config.field
      state.rtDaySortOrder = config.order
    },
    setRtDayPage(state: any, result:any) {
      state.rtDayPage = result
    },
    setRtDayResults(state: any, result:any) {
      state.rtDayResults = result
    },
    setRtWeek(state: any, result:any) {
      state.rtWeek = result
    },
    setWeekSorting(state: any, config:any) {
      state.rtWeekSortField = config.field
      state.rtWeekSortOrder = config.order
    },
    setRtWeekPage(state: any, result:any) {
      state.rtWeekPage = result
    },
    setRtWeekResults(state: any, result:any) {
      state.rtWeekResults = result
    },
    setRtMonth(state: any, result:any) {
      state.rtMonth = result
    },
    setRtLastMonth(state: any, result:any) {
      state.rtLastMonth = result
    },
    setMonthSorting(state: any, config:any) {
      state.rtMonthSortField = config.field
      state.rtMonthSortOrder = config.order
    },
    setLastMonthSorting(state: any, config:any) {
      state.rtLastMonthSortField = config.field
      state.rtLastMonthSortOrder = config.order
    },
    setRtMonthPage(state: any, result:any) {
      state.rtMonthPage = result
    },
    setRtLastMonthPage(state: any, result:any) {
      state.rtLastMonthPage = result
    },
    setRtMonthResults(state: any, result:any) {
      state.rtMonthResults = result
    },
    setRtLastMonthResults(state: any, result:any) {
      state.rtLastMonthResults = result
    },
    setRtAll(state: any, result:any) {
      state.rtAll = result
    },
    setAllSorting(state: any, config:any) {
      state.rtAllSortField = config.field
      state.rtAllSortOrder = config.order
    },
    setRtAllPage(state: any, result:any) {
      state.rtAllPage = result
    },
    setRtAllResults(state: any, result:any) {
      state.rtAllResults = result
    },
  },
  actions: {
    getRunningTrackAll({ commit, dispatch, rootState }: any) {
      firebase.firestore().collection('users_running').where('company', '==', rootState.authen.user.company).get()
        .then(async (querySnapshot) => {
          let user_running: Array<any> = [];
          querySnapshot.forEach((doc) => {
            if (doc.data().distance > 0)
              user_running.push(doc.data());
          });
          user_running = _.orderBy(user_running, ['distance'], ['desc'])
          //console.log('user_running',user_running)
          commit('setUserRunning', user_running)
        });
    },
    dayOnCreate({ state, commit }: any, data: any) {
      for (let i = 0; i < data.length; i++) {
        data[i].rank = i + 1;
      }
      commit("setRtDay", data);
      commit("setRtDayResults", data.length);
    },
    weekOnCreate({ state, commit }: any, data: any) {
      for (let i = 0; i < data.length; i++) {
        data[i].rank = i + 1;
      }
      commit("setRtWeek", data);
      commit("setRtWeekResults", data.length);
    },
    monthOnCreate({ state, commit }: any, data: any) {
      //console.log('data',data)
      for (let i = 0; i < data.length; i++) {
        data[i].rank = i + 1;
      }
      commit("setRtMonth", data);
      commit("setRtMonthResults", data.length);
    },
    lastMonthOnCreate({ state, commit }: any, data: any) {
      //console.log('lastMonthOnCreate',data)
      for (let i = 0; i < data.length; i++) {
        data[i].rank = i + 1;
      }
      commit("setRtLastMonth", data);
      commit("setRtLastMonthResults", data.length);
    },
    allOnCreate({ state, commit }: any, data: any) {
      for (let i = 0; i < data.length; i++) {
        data[i].rank = i + 1;
      }
      commit("setRtAll", data);
      commit("setRtAllResults", data.length);
    },
  },
  getters: {
    user_running: ({ user_running }) => {
      return user_running
    },
    toDayData: ({
      rtDay,
      rtDayPage,
      inputSearching,
      rtDaySortField,
      rtDaySortOrder,
      sizePage
    }) => {
      let toDayData: Array<any> = [];
      toDayData.push(rtDay)
      let textSearching = inputSearching;
      if (textSearching.length > 0) {
        if (toDayData.length > 0) {
          let re = new RegExp(textSearching, 'gi')
          let response = _.filter(rtDay, (item): any => {
            if (item.name.match(re)) {
              return true
            }
          });
          toDayData = []
          toDayData.push(response)
        }
      }

      let field = rtDaySortField
      let order = rtDaySortOrder
      if (field === "distance") {
        if (order === "ascending") {
          order = 'desc'
        } else {
          order = 'asc'
        }
      } else {
        if (order === "ascending") {
          order = 'asc'
        } else {
          order = 'desc'
        }
      }
      let sortDayData = _.orderBy(toDayData[0], [field], [order])
      let start_row = (rtDayPage - 1) * sizePage
      let end_row = ((rtDayPage - 1) * sizePage) + sizePage
      return {
        dataTable: sortDayData.slice(start_row, end_row),
        page: rtDayPage,
        results: sortDayData.length
      }
    },
    weekData: ({
      rtWeek,
      rtWeekPage,
      inputSearching,
      rtWeekSortField,
      rtWeekSortOrder,
      sizePage
    }) => {
      let toWeekData: Array<any> = [];
      toWeekData.push(rtWeek)
      let textSearching = inputSearching;
      if (textSearching.length > 0) {
        if (toWeekData.length > 0) {
          let re = new RegExp(textSearching, 'gi')
          let response = _.filter(rtWeek, (item): any => {
            if (item.name.match(re)) {
              return true
            }
          });
          toWeekData = []
          toWeekData.push(response)
        }
      }

      let field = rtWeekSortField
      let order = rtWeekSortOrder
      if (field === "distance") {
        if (order === "ascending") {
          order = 'desc'
        } else {
          order = 'asc'
        }
      } else {
        if (order === "ascending") {
          order = 'asc'
        } else {
          order = 'desc'
        }
      }
      let sortWeekData = _.orderBy(toWeekData[0], [field], [order])
      let start_row = (rtWeekPage - 1) * sizePage
      let end_row = ((rtWeekPage - 1) * sizePage) + sizePage
      return {
        dataTable: sortWeekData.slice(start_row, end_row),
        page: rtWeekPage,
        results: sortWeekData.length
      }
    },
    monthData: ({
      rtMonth,
      rtMonthPage,
      inputSearching,
      rtMonthSortField,
      rtMonthSortOrder,
      sizePage
    }) => {
      let toMonthData: Array<any> = [];
      toMonthData.push(rtMonth)
      let textSearching = inputSearching;
      if (textSearching.length > 0) {
        if (toMonthData.length > 0) {
          let re = new RegExp(textSearching, 'gi')
          let response = _.filter(rtMonth, (item): any => {
            if (item.name.match(re)) {
              return true
            }
          });
          toMonthData = []
          toMonthData.push(response)
        }
      }

      let field = rtMonthSortField
      let order = rtMonthSortOrder
      if (field === "distance") {
        if (order === "ascending") {
          order = 'desc'
        } else {
          order = 'asc'
        }
      } else {
        if (order === "ascending") {
          order = 'asc'
        } else {
          order = 'desc'
        }
      }
      let sortMonthData = _.orderBy(toMonthData[0], [field], [order])
      let start_row = (rtMonthPage - 1) * sizePage
      let end_row = ((rtMonthPage - 1) * sizePage) + sizePage
      return {
        dataTable: sortMonthData.slice(start_row, end_row),
        page: rtMonthPage,
        results: sortMonthData.length
      }
    },
    lastMonthData: ({
      rtLastMonth,
      rtLastMonthPage,
      inputSearching,
      rtLastMonthSortField,
      rtLastMonthSortOrder,
      sizePage
    }) => {
      let toLastMonthData: Array<any> = [];
      toLastMonthData.push(rtLastMonth)
      let textSearching = inputSearching;
      if (textSearching.length > 0) {
        if (toLastMonthData.length > 0) {
          let re = new RegExp(textSearching, 'gi')
          let response = _.filter(rtLastMonth, (item): any => {
            if (item.name.match(re)) {
              return true
            }
          });
          toLastMonthData = []
          toLastMonthData.push(response)
        }
      }

      let field = rtLastMonthSortField
      let order = rtLastMonthSortOrder
      if (field === "distance") {
        if (order === "ascending") {
          order = 'desc'
        } else {
          order = 'asc'
        }
      } else {
        if (order === "ascending") {
          order = 'asc'
        } else {
          order = 'desc'
        }
      }
      let sortLastMonthData = _.orderBy(toLastMonthData[0], [field], [order])
      //console.log('sortLastMonthData',sortLastMonthData)
      let start_row = (rtLastMonthPage - 1) * sizePage
      let end_row = ((rtLastMonthPage - 1) * sizePage) + sizePage
      return {
        dataTable: sortLastMonthData.slice(start_row, end_row),
        page: rtLastMonthPage,
        results: sortLastMonthData.length
      }
    },
    allData: ({
      rtAll,
      rtAllPage,
      inputSearching,
      rtAllSortField,
      rtAllSortOrder,
      sizePage
    }) => {
      let toAllData: Array<any> = [];
      toAllData.push(rtAll)
      let textSearching = inputSearching;
      if (textSearching.length > 0) {
        if (toAllData.length > 0) {
          let re = new RegExp(textSearching, 'gi')
          let response = _.filter(rtAll, (item): any => {
            if (item.name.match(re)) {
              return true
            }
          });
          toAllData = []
          toAllData.push(response)
        }
      }

      let field = rtAllSortField
      let order = rtAllSortOrder
      if (field === "distance") {
        if (order === "ascending") {
          order = 'desc'
        } else {
          order = 'asc'
        }
      } else {
        if (order === "ascending") {
          order = 'asc'
        } else {
          order = 'desc'
        }
      }
      let sortAllData = _.orderBy(toAllData[0], [field], [order])
      let start_row = (rtAllPage - 1) * sizePage
      let end_row = ((rtAllPage - 1) * sizePage) + sizePage
      return {
        dataTable: sortAllData.slice(start_row, end_row),
        page: rtAllPage,
        results: sortAllData.length
      }
    },
  }
}